import React from 'react';
import ReactDOM from 'react-dom/client';
import './design-system/boliche/tokens.css'; // tokens del DS (--bg-page, --lava-*, Saira/Barlow) en TODAS las rutas; antes de index.css para que shadcn (--accent, etc.) gane la colisión
import './index.css';
import App from './App';
import { Toaster } from 'sonner';
import { AuthProvider } from './hooks/useAuth';

// Detectar Safari
const isSafari = typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Safari: Sin StrictMode para mejor rendimiento inicial (evita double render)
// Chrome: Mantener StrictMode para desarrollo
if (isSafari) {
  root.render(
    <AuthProvider>
      <App />
      <Toaster
        position="top-right"
        richColors
        closeButton
        expand={false}
      />
    </AuthProvider>
  );
} else {
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
        <Toaster
          position="top-right"
          richColors
          closeButton
          expand={false}
        />
      </AuthProvider>
    </React.StrictMode>
  );
}